<template>
  <main-container>
    <a-card style="margin-bottom: 20px">
      <a-descriptions :column="2">
        <a-descriptions-item label="会员ID" :span="1">
          <router-link :to="{ name: $routeName.memberDetail, query: { id: orderDeatil.user.user_id } }">
            <p>{{ orderDeatil.user.user_id }}</p>
          </router-link>
        </a-descriptions-item>
        <a-descriptions-item label="会员等级" :span="1">
          <span v-if="orderDeatil.user.user_level == 0">销售价格</span>
          <span v-if="orderDeatil.user.user_level == 1">一级会员价格</span>
          <span v-if="orderDeatil.user.user_level == 2">二级会员价格</span>
          <span v-if="orderDeatil.user.user_level == 3">三级会员价格</span>
          <span v-if="orderDeatil.user.user_level == 4">四级会员价格</span>
          <span v-if="orderDeatil.user.user_level == 5">五级会员价格</span>
        </a-descriptions-item>
        <a-descriptions-item label="会员昵称" :span="1">
          {{ orderDeatil.user.name }}
        </a-descriptions-item>
        <a-descriptions-item label="会员账号" :span="1">
          {{ orderDeatil.user.email }}
        </a-descriptions-item>
        <a-descriptions-item label="手机号" :span="1">
          {{ orderDeatil.user.phone }}
        </a-descriptions-item>
        <!--        <a-descriptions-item label="个体" :span="1" v-if="newUserDetai.type==1"></a-descriptions-item>-->
        <!--        <a-descriptions-item label="公司" :span="1" v-if="newUserDetai.type==2"></a-descriptions-item>-->
        <!--        <a-descriptions-item label="税号类型" :span="1">-->
        <!--          <span v-if="newUserDetai.type==1">CIF</span>-->
        <!--          <span v-if="newUserDetai.type==2">NIF</span>-->
        <!--        </a-descriptions-item>-->
        <!--        <a-descriptions-item label="公司名称" :span="1">-->
        <!--          {{ newUserDetai.company }}-->
        <!--        </a-descriptions-item>-->
        <!--        <a-descriptions-item label="姓" :span="1">-->
        <!--          {{ newUserDetai.lname }}-->
        <!--        </a-descriptions-item>-->
        <!--        <a-descriptions-item label="名" :span="1">-->
        <!--          {{ newUserDetai.fname }}-->
        <!--        </a-descriptions-item>-->
        <!--        <a-descriptions-item label="城市" :span="1">-->
        <!--          {{ newUserDetai.city }}-->
        <!--        </a-descriptions-item>-->
        <!--        <a-descriptions-item label="地址" :span="1">-->
        <!--          {{ newUserDetai.postcode }}-->
        <!--        </a-descriptions-item>-->
        <!--        <a-descriptions-item label="邮编" :span="1">-->
        <!--          {{ orderDeatil.user.phone }}-->
        <!--        </a-descriptions-item>-->
      </a-descriptions>
    </a-card>
    <a-card>
      <a-descriptions :column="2">
        <a-descriptions-item label="物流订单号">
          {{ orderDeatil.order_id }}
        </a-descriptions-item>
        <a-descriptions-item label="">
          订单状态： {{ orderDeatil.status_text }}
          <div v-if="orderDeatil.finish_time "> 手动设置完成时间： {{ orderDeatil.finish_time }} </div>
        </a-descriptions-item>
        <a-descriptions-item label="订单总价">
          {{ orderDeatil.total_price }}（订单金额：{{ orderDeatil.price }} € + IVA{{ orderDeatil.IVA }}€ ）
        </a-descriptions-item>
        <a-descriptions-item>
          <a-button type="primary" @click="showModal">
            修改金额
          </a-button>
          <!--          <a-button style="margin-left: 20px" type="primary" @click="priceSpread = true">-->
          <!--            补差价-->
          <!--          </a-button>-->
        </a-descriptions-item>
        <a-descriptions-item label="实收" v-if="orderDeatil.real_price != orderDeatil.total_price">
          {{ orderDeatil.real_price }}（补缴金额{{ (orderDeatil.real_price - orderDeatil.total_price).toFixed(2) }}）
        </a-descriptions-item>
        <a-descriptions-item label="购买保险">
          {{ orderDeatil.is_insurance == 1 ? '是' : '否' }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ orderDeatil.create_time }}
        </a-descriptions-item>
        <a-descriptions-item label="付款方式">
          {{ orderDeatil.pay_type }}
        </a-descriptions-item>
        <a-descriptions-item label="付款时间">
          {{ orderDeatil.pay_time }}
        </a-descriptions-item>
        <a-descriptions-item label="要求上门取件的时间">
          {{ orderDeatil.pick_up_date }}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
    <a-card style="margin-top: 24px">
      <a-descriptions :column="2">
        <a-descriptions-item label="物流路线" :span="2">
          {{ orderDeatil.service }}
        </a-descriptions-item>
        <a-descriptions-item label="取件日期" :span="2">
          {{ orderDeatil.pick_up_date }}
        </a-descriptions-item>
        <a-descriptions-item label="发件地址" :span="2">
          {{ orderDeatil.send_address.full_name }} , {{ orderDeatil.send_address.phone }},
          {{ orderDeatil.send_address.country_name }}, {{ orderDeatil.send_address.city }},
          {{ orderDeatil.send_address.address }},
          {{ orderDeatil.send_address.post_code }}
        </a-descriptions-item>
        <a-descriptions-item label="发件人邮箱" :span="2">
          {{ orderDeatil.send_address.email }}
        </a-descriptions-item>
        <a-descriptions-item label="发件人微信号" :span="2">
          {{ orderDeatil.send_address.wx_account }}
        </a-descriptions-item>
        <a-descriptions-item label="取件码" :span="2">
          {{ orderDeatil.pick_up_code }}
        </a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">
          {{ orderDeatil.cancel }}
        </a-descriptions-item>
        <a-descriptions-item label="包裹数" :span="2">
          {{ orderDeatil.package_num }}
        </a-descriptions-item>
        <a-descriptions-item label="用户填写重量" :span="2"> {{ orderDeatil.input_weight }}kg </a-descriptions-item>
        <a-descriptions-item label="长" :span="2"> {{ orderDeatil.length }}cm </a-descriptions-item>
        <a-descriptions-item label="宽" :span="2"> {{ orderDeatil.width }}cm </a-descriptions-item>
        <a-descriptions-item label="高" :span="2"> {{ orderDeatil.height }}cm </a-descriptions-item>
        <a-descriptions-item label="总重量" :span="2"> {{ orderDeatil.weight }}kg </a-descriptions-item>
      </a-descriptions>
    </a-card>
    <a-card style="margin-top: 24px">
      <template slot="title">
        <div>
          包裹信息
          <span style="color: red"> （出单进度{{ orderDeatil.package_info.progress }}） </span>
        </div>
      </template>
      <template slot="extra">
        <div>
          <a-button type="primary" v-if="orderDeatil.status<7" @click="handleComplete()">设为完成</a-button>
          <a-button style="margin-left: 20px" type="danger" ghost icon="download" @click="handleAllDownload">
            下载全部面单
          </a-button>
          <a-button
            style="margin-left: 20px"
            type="primary"
            ghost
            icon="printer"
            @click="handleAllPrint"
            :loading="isLoading"
          >
            打印全部面单
          </a-button>
        </div>
      </template>
      <div style="display: flex; justify-content: space-between;margin-bottom: 10px">
        <h4>
          {{ orderDeatil.package_info.type }}
        </h4>
        <div style="color: red">
          注意：请务必打印面单，并贴至包裹
        </div>
      </div>
      <a-table
        :columns="columns"
        row-key="line_no"
        :data-source="orderDeatil.package_info.line_list"
        :pagination="false"
      >
        <template slot="line_no" slot-scope="record">
          <div style="color:red; cursor: pointer" @click="handleLinkOrder(record)">{{ record.line_no }}</div>
        </template>
        <template slot="money" slot-scope="money"> {{ money }} € </template>
        <template slot="action" slot-scope="record">
          <a-button type="link" @click="handleDownload(record)">下载面单</a-button>
          <a-button type="link" @click="handlePrint(record)">打印面单</a-button>
        </template>
      </a-table>
      <div style="margin-top: 20px">
        收件地址：
        {{ orderDeatil.package_info.receive_address.full_name }} , {{ orderDeatil.package_info.receive_address.phone }},
        {{ orderDeatil.package_info.receive_address.country_name }},
        {{ orderDeatil.package_info.receive_address.city }},{{ orderDeatil.package_info.receive_address.address }},
        {{ orderDeatil.package_info.receive_address.address1 }},
        {{ orderDeatil.package_info.receive_address.post_code }}
      </div>
      <div style="margin-top: 10px">收件人邮箱：{{ orderDeatil.package_info.receive_address.email }}</div>
      <div style="margin-top: 10px">收件人微信号：{{ orderDeatil.package_info.receive_address.wx_account }}</div>
    </a-card>

    <a-modal v-model="visible" title="修改订单价格" @ok="handleOk" okText="确认已补缴">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="现收金额">
          <a-input v-model="form.now_price" disabled />
        </a-form-model-item>
        <a-form-model-item label="实际应收金额" prop="real_price">
          <a-input v-model="form.real_price" />
        </a-form-model-item>
        <p style="text-align: center">
          客户应补缴金额
          <span style="color: red">
            {{ diff_price }}
          </span>
        </p>
      </a-form-model>
    </a-modal>
    <a-modal v-model="priceSpread" title="补差价" @ok="priceSpreadOk" okText="确认补差">
      <a-form-model ref="ruleForm" :model="formPrice" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="现收金额">
          <a-input v-model="orderDeatil.total_price" disabled />
        </a-form-model-item>
        <a-form-model-item label="实际应收金额" prop="amount">
          <a-input v-model="formPrice.amount" />
        </a-form-model-item>
        <p style="text-align: center">
          客户应补差价
          <span style="color: red">
            {{ diff_price_1 }}
          </span>
        </p>
      </a-form-model>
    </a-modal>
  </main-container>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { saveAs } from 'file-saver';
import { PDFDocument } from 'pdf-lib';
import print from 'print-js';

import Order from '@/api/order';
const columns = [
  {
    title: '序号',
    dataIndex: 'line_num',
  },
  {
    title: '状态',
    dataIndex: 'line_status',
  },
  {
    title: '物流单号',
    scopedSlots: { customRender: 'line_no' },
  },
  {
    title: '金额',
    dataIndex: 'money',
    scopedSlots: { customRender: 'money' },
  },
  {
    key: 'action',
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  name: 'OrderDetail',

  data() {
    return {
      orderDeatil: {
        send_address: {},
        package_info: {
          receive_address: {},
        },
        user: {},
      },
      form: {
        now_price: '',
        real_price: '',
      },
      formPrice: {
        amount: '',
      },
      diff_price: 0, // 补缴金额
      diff_price_1: 0, // 补差金额
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      columns,
      visible: false,
      priceSpread: false,
      rules: {
        real_price: [{ required: true, message: '请填写实际应收金额', trigger: 'blur' }],
      },
      isLoading: false,
      newUserDetai: {},
    };
  },

  watch: {
    'form.real_price'(val) {
      console.log('====', val);
      if (val) {
        this.diff_price = (val - this.orderDeatil.total_price).toFixed(2);
      } else {
        this.diff_price = 0;
      }
    },
    'formPrice.amount'(val) {
      console.log('val', val);
      if (val) {
        this.diff_price_1 = (val - this.orderDeatil.total_price).toFixed(2);
      } else {
        this.diff_price_1 = 0;
      }
    },
  },

  created() {
    this.loadOrderDetail();
  },

  methods: {
    loadOrderDetail() {
      Order.orderDetail({ id: this.$route.query.id }).then(({ data }) => {
        this.orderDeatil = data;
        this.form.now_price = this.orderDeatil.total_price;
        this.getUserInfo(data.user.user_id);
      });
    },

    handleComplete() {
      Modal.confirm({
        title: '提示',
        content: '确认设置为完成状态吗？',
        confirmLoading: this.confirmLoading,
        onOk: () => {
          Order.setComplete({ id: this.$route.query.id, status: 7 }).then(({ data }) => {
            console.log(data)
            this.orderDeatil.finish_time = data.finish_time
            this.orderDeatil.status = data.status
            this.orderDeatil.status_text = data.status_text
            this.$message.success('设置成功');
          });
        },
      });
      
    },

    handleDownload(item) {
      const oReq = new XMLHttpRequest();
      const URLToPDF = item.line_url;
      oReq.open('GET', URLToPDF, true);
      oReq.responseType = 'blob';
      oReq.onload = function() {
        const file = new Blob([oReq.response], {
          type: 'application/pdf',
        });
        saveAs(file, `${item.line_no}.pdf`);
      };
      oReq.send();
    },

    handlePrint(item) {
      print({ printable: item.line_url });
    },

    handleAllDownload() {
      this.orderDeatil.package_info.line_list.map(item => {
        this.handleDownload(item);
      });
    },

    handleLinkOrder(record) {
      window.open(process.env.VUE_APP_ORDER_URL + record.line_no);
    },

    async printPDFS(pdfsToMerge) {
      const mergedPdf = await PDFDocument.create();
      for (const pdfCopyDoc of pdfsToMerge) {
        const pdfBytes = await fetch(pdfCopyDoc).then(res => res.arrayBuffer());
        const pdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach(page => {
          mergedPdf.addPage(page);
        });
      }

      const mergedPdfFile = await mergedPdf.save();
      this.downloadFile(mergedPdfFile);
    },

    downloadFile(data) {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      this.isLoading = false;
      print({
        printable: url,
        type: 'pdf',
      });
    },

    // 批量打印
    handleAllPrint() {
      this.isLoading = true;
      Order.printAll({ id: this.$route.query.id }).then(({ data }) => {
        this.printPDFS(data);
      });
    },

    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const payload = {
            real_price: this.form.real_price,
            diff_price: this.diff_price,
            id: this.$route.query.id,
          };
          this.visible = false;
          Order.updatePrice(payload).then(res => {
            if (res.status == 'success') {
              this.$message.success('修改成功');
              this.loadOrderDetail();
            }
          });
        }
      });
    },
    priceSpreadOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const payload = {
            amount: this.formPrice.amount,
            id: this.$route.query.id,
          };
          this.visible = false;
          Order.subtractAmount(payload).then(res => {
            if (res.status == 'success') {
              this.$message.success('修改成功');
              this.loadOrderDetail();
            }
          });
        }
      });
    },
    getUserInfo(user_id) {
      Order.getUserInfo({ user_id: user_id }).then(res => {
        this.newUserDetai = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less"></style>
